import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/frontend-plugin-api';
import { mapEventsToEventDataItems } from '../mappers/eventDataMappers';
import { EventData } from '../types/EventData';
import { TruncationLimits } from '../types/TruncationLimits';
import { QUERY_KEYS } from './queryKeys';
import { getTagsFromEvents } from '../utils/EventHelpers';
import { calendarApiRef } from '../api/ref';
import { PENDING_INVITATION_REFETCH_INTERVAL_MS, hasPendingInvitation } from './pendingInvitation';

export function useCalendarEvents(truncationLimits: TruncationLimits) {
  const calendarClient = useApi(calendarApiRef);

  const {
    data: calendarEvents,
    isLoading,
    error,
  } = useQuery({
    queryKey: QUERY_KEYS.allEvents(),
    queryFn: () => calendarClient.getEvents(),
    refetchInterval: query =>
      hasPendingInvitation(query.state.data) ? PENDING_INVITATION_REFETCH_INTERVAL_MS : false,
  });

  if (!calendarEvents) {
    return { eventRows: [] as EventData[], tags: [] as string[], isLoading, error };
  }

  const eventRows = mapEventsToEventDataItems(calendarEvents, truncationLimits);
  const tags = getTagsFromEvents(eventRows || []);
  return { eventRows, tags, isLoading, error };
}
